import { render, staticRenderFns } from "./reviews-table.vue?vue&type=template&id=122e1245&scoped=true"
import script from "./reviews-table.vue?vue&type=script&lang=js"
export * from "./reviews-table.vue?vue&type=script&lang=js"
import style0 from "./reviews-table.vue?vue&type=style&index=0&id=122e1245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e1245",
  null
  
)

export default component.exports